import React, { useState, useEffect, useContext, useRef } from "react";
import { AuthContext } from "../../context/auth";
import axios from "axios";
import { useParams, useNavigate } from "react-router-dom";
import "./EditEvent.css";
import LandmarkInput from "../../components/landmarkInput/LandmarkInput";
import UploadEventImageModal from "../../Modals/uploadEventImageModal/UploadEventImageModal";
import AsoEbiModal from "../../Modals/asoEbiModal/AsoEbiModal";
import CashGiftModal from "../../Modals/cashGiftModal/CashGiftModal";
import EntryTicketModal from "../../Modals/entryTicketModal/EntryTicketModal";
import DateOptionsModal from "../../Modals/dateOptionsModal/DateOptionsModal";
import DateTimeCustomizationModal from "../../Modals/dateTimeCustomizationModal/DateTimeCustomizationModal";
import DateTimeModal from "../../Modals/dateTimeModal/DateTimeModal";
import EditEventSuccessmodal from "../../Modals/editEventSuccessmodal/EditEventSuccessmodal";
import CustomButton from "../../components/customButton/CustomButton";
import Header from "../../components/header/Header";
import EventHeader from "../../components/eventHeader/EventHeader";
import {
  formatDateToLocal,
  compressImage,
  uploadImageToBlob,
  convertTime12HourTo24Hour,
  formatDateForEditInput,
  formatTimeForEditInput,
  createDateFromEditInput,
  formatDateForBackend,
  formatTimeForBackend,
} from "../../helper/utils";
import { CheckIcon, DownArrowIcon } from "../../helper/icon";

const ImagePlaceholder = () => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M9 22H15C20 22 22 20 22 15V9C22 4 20 2 15 2H9C4 2 2 4 2 9V15C2 20 4 22 9 22Z"
      stroke="#292D32"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M9 10C10.1046 10 11 9.10457 11 8C11 6.89543 10.1046 6 9 6C7.89543 6 7 6.89543 7 8C7 9.10457 7.89543 10 9 10Z"
      stroke="#292D32"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M2.67 18.95L7.6 15.64C8.39 15.11 9.53 15.17 10.24 15.78L10.57 16.07C11.35 16.74 12.61 16.74 13.39 16.07L17.55 12.5C18.33 11.83 19.59 11.83 20.37 12.5L22 13.9"
      stroke="#292D32"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

const ErrorText = ({ error }) => {
  if (!error) return null;
  return <p className="edit-event-error-text">{error}</p>;
};

const EditEvent = () => {
  const { user } = useContext(AuthContext);
  const { eventId } = useParams();
  const navigate = useNavigate();
  const preferredCurrencyRef = useRef(null);

  const [eventData, setEventData] = useState(null);
  const [isLoading, setIsLoading] = useState(true);
  const [isSaving, setIsSaving] = useState(false);

  const [showEventTypeDropdown, setShowEventTypeDropdown] = useState(false);
  const [isOtherEventType, setIsOtherEventType] = useState(false);
  const [customEventType, setCustomEventType] = useState("");
  const [showCurrencyDropdown, setShowCurrencyDropdown] = useState(false);

  const [showDateOptionsModal, setShowDateOptionsModal] = useState(false);
  const [showDateTimeCustomizationModal, setShowDateTimeCustomizationModal] =
    useState(false);
  const [showDateTimeModal, setShowDateTimeModal] = useState(false);
  const [isAdditionalDatesChecked, setIsAdditionalDatesChecked] =
    useState(false);
  const [isSaveClicked, setIsSaveClicked] = useState(false);
  const [currentOptionSet, setCurrentOptionSet] = useState([]);

  const [landmark, setLandmark] = useState("");
  const [landmarkCoords, setLandmarkCoords] = useState(null);
  const [customAddress, setCustomAddress] = useState("");
  const [showCustomAddressField, setShowCustomAddressField] = useState(false);

  const [showUploadEventImageModal, setShowUploadEventImageModal] =
    useState(false);
  const [showAsoEbiModal, setShowAsoEbiModal] = useState(false);
  const [showCashGiftModal, setShowCashGiftModal] = useState(false);
  const [showEntryTicketModal, setShowEntryTicketModal] = useState(false);
  const [successModalVisible, setSuccessModalVisible] = useState(false);

  const [showVisibilityDropdown, setShowVisibilityDropdown] = useState(false);
  const visibilityRef = useRef(null);

  const [selectedImages, setSelectedImages] = useState([]);

  const [asoEbiData, setAsoEbiData] = useState({
    asoEbiImages: [],
    refundDeadlineDate: null,
    isEventAttireCompulsory: false,
  });

  const [validationErrors, setValidationErrors] = useState({});

  const [eventResponse, setEventResponse] = useState(null);

  const eventTypes = [
    "Wedding",
    "Burial",
    "Birthday",
    "Conference",
    "Meet-up",
    "Others",
  ];

  const currencyOptions = [
    { value: "NGN", label: "Naira (₦)", symbol: "₦" },
    { value: "USD", label: "Dollar ($)", symbol: "$" },
  ];

  const dateOptionsSet1 = [
    {
      id: "multiple",
      title: "Multiple Date & Time",
      description: "My Event has multiple time, date & location",
    },
    {
      id: "startEnd",
      title: "Start & End Date",
      description: "My Event has start date and time",
    },
  ];

  const dateOptionsSet2 = [
    {
      id: "multiple",
      title: "Multiple Date & Time",
      description: "My Event has multiple time, date & location",
    },
    {
      id: "regular",
      title: "Regular Event",
      description: "A day Event, single date & time",
    },
  ];

  const dateOptionsSet3 = [
    {
      id: "regular",
      title: "Regular Event",
      description: "A day Event, single date & time",
    },
    {
      id: "startEnd",
      title: "Start & End Date",
      description: "My Event has start date and time",
    },
  ];

  useEffect(() => {
    fetchEventById();
  }, [eventId]);

  useEffect(() => {
    return () => {
      selectedImages.forEach((image) => {
        if (image.uri?.startsWith("blob:")) {
          URL.revokeObjectURL(image.uri);
        }
      });
    };
  }, [selectedImages]);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const handleVisibilitySelect = (visibility) => {
    setEventData((prev) => {
      if (!prev) return prev;
      return { ...prev, visibility };
    });
    setShowVisibilityDropdown(false);
    if (validationErrors.visibility) {
      setValidationErrors((prev) => ({ ...prev, visibility: "" }));
    }
  };

  const fetchEventById = async () => {
    try {
      setIsLoading(true);
      const response = await axios.get(`/event/${eventId}`);
      if (response.data.successStatus) {
        const fetchedEvent = response.data.data;

        const processedEvent = {
          ...fetchedEvent,
          visibility: fetchedEvent.visibility || "public",
          eventLandmark:
            fetchedEvent.eventLandmark || fetchedEvent.landmark || "",
          location: fetchedEvent.location || fetchedEvent.eventLocation || "",
        };

        setEventData(processedEvent);

        if (fetchedEvent.eventImages) {
          setSelectedImages(fetchedEvent.eventImages);
        }

        if (fetchedEvent.eventAttire) {
          setAsoEbiData({
            asoEbiImages: fetchedEvent.eventAttire.asoEbiImages || [],
            refundDeadlineDate:
              fetchedEvent.eventAttire.refundDeadlineDate || null,
            isEventAttireCompulsory:
              fetchedEvent.eventAttire.isEventAttireCompulsory || false,
          });
        }

        if (fetchedEvent.eventLandmark) {
          setLandmark(fetchedEvent.eventLandmark);
        }

        if (fetchedEvent.customAddress) {
          setCustomAddress(fetchedEvent.customAddress);
        }

        if (fetchedEvent.landmarkCoords) {
          setLandmarkCoords(fetchedEvent.landmarkCoords);
        }

        if (
          fetchedEvent.dateOption === "multiple" ||
          fetchedEvent.dateOption === "startEnd"
        ) {
          setIsAdditionalDatesChecked(true);
          setIsSaveClicked(true);
        }
      }
    } catch (error) {
      // console.error("Error fetching event:", error);
      // alert("Failed to load event data");
    } finally {
      setIsLoading(false);
    }
  };

  const validateEventData = (data) => {
    if (!data) {
      return { isValid: false, errors: { general: "Event data is missing" } };
    }

    const errors = {};

    if (!data.eventType?.trim()) errors.eventType = "Required";
    if (!data.eventTitle?.trim()) errors.eventTitle = "Required";
    if (!data.eventDescription?.trim()) errors.description = "Required";
    if (!data.eventImages || data.eventImages.length === 0)
      errors.eventImages = "At least one image required";
    if (!data.preferredCurrency) errors.preferredCurrency = "Required";

    switch (data.dateOption) {
      case "multiple":
        data.multipleDates?.forEach((entry, index) => {
          if (!entry.subTitle?.trim())
            errors[`dateTitle_${index}`] = "Required";
          if (!entry.date) errors[`dateDate_${index}`] = "Required";
          if (!entry.time) errors[`dateTime_${index}`] = "Required";
          if (!entry.location?.trim())
            errors[`dateLocation_${index}`] = "Required";
        });
        break;

      case "startEnd":
        if (!data.startDate) errors.startDate = "Required";
        if (!data.endDate) errors.endDate = "Required";
        if (!data.startTime) errors.startTime = "Required";
        if (!data.location?.trim() && !data.eventLocation?.trim()) {
          errors.location = "Required";
        }
        break;

      case "regular":
        if (!data.eventDate) errors.eventDate = "Required";
        if (!data.eventTime) errors.eventTime = "Required";
        if (!data.location?.trim() && !data.eventLocation?.trim()) {
          errors.location = "Required";
        }
        break;

      default:
        if (!data.eventDate) errors.eventDate = "Required";
        if (!data.eventTime) errors.eventTime = "Required";
        if (!data.location?.trim() && !data.eventLocation?.trim()) {
          errors.location = "Required";
        }
    }

    return { isValid: Object.keys(errors).length === 0, errors };
  };

  const scrollToFirstError = (errors) => {
    const firstErrorField = Object.keys(errors)[0];
    if (!firstErrorField) return;
    const fieldElement = document.querySelector(
      `[data-error="${firstErrorField}"]`,
    );
    if (fieldElement) {
      fieldElement.scrollIntoView({ behavior: "smooth", block: "center" });
    }
  };

  const handleEventAttireUpload = async (completeEventData, updateCallback) => {
    if (!completeEventData.eventAttire?.asoEbiImages) return;
    if (completeEventData.eventAttire.asoEbiImages.length === 0) return;

    const updatedImages = await Promise.all(
      completeEventData.eventAttire.asoEbiImages.map(async (asset, index) => {
        if (
          asset.uri?.startsWith("http://") ||
          asset.uri?.startsWith("https://")
        ) {
          return {
            uri: asset.uri,
            price: asset.price || "0",
            attireTag: asset.attireTag || "",
          };
        }

        if (asset.uri?.startsWith("blob:") && asset.file) {
          if (!(asset.file instanceof File)) {
            // console.error(`Image ${index} - asset.file is not a File object`);
            return null;
          }

          try {
            const blobResponse = await uploadImageToBlob(
              asset.file,
              asset.file.name || `asoebi_${index}.jpeg`,
              "asoebi",
            );

            const blobUrl = blobResponse?.data?.Location;

            if (!blobUrl) {
              // console.error(
              //   `Upload failed for image ${index} - no URL returned`
              // );
              return null;
            }

            return {
              uri: blobUrl,
              price: asset.price || "0",
              attireTag: asset.attireTag || "",
            };
          } catch (error) {
            console.error(`Attire upload error for image ${index}:`, error);
            return null;
          }
        }

        return null;
      }),
    );

    const validUpdatedImages = updatedImages.filter(Boolean);

    if (validUpdatedImages.length > 0) {
      const updatedEventAttire = {
        ...completeEventData.eventAttire,
        asoEbiImages: validUpdatedImages,
      };

      updateCallback({
        eventAttire: updatedEventAttire,
      });
    }
  };

  const handleEventImageUpload = async (completeEventData, updateCallback) => {
    const updatedImages = [];

    for (let i = 0; i < completeEventData.eventImages.length; i++) {
      const asset = completeEventData.eventImages[i];

      if (
        asset.uri?.startsWith("http://") ||
        asset.uri?.startsWith("https://")
      ) {
        updatedImages.push({
          uri: asset.uri,
          type: asset.type,
          name: asset.name,
        });
        continue;
      }

      if (asset.uri?.startsWith("blob:")) {
        if (!asset.file || !(asset.file instanceof File)) {
          alert(`Image ${i + 1} is invalid. Please re-upload it.`);
          continue;
        }

        try {
          const blobResponse = await uploadImageToBlob(
            asset.file,
            asset.file.name || `event_photo_${i}.jpeg`,
            "event",
          );

          const blobUrl = blobResponse?.data?.Location;

          if (!blobUrl) {
            // throw new Error("Upload failed - no URL returned");
          }

          updatedImages.push({
            uri: blobUrl,
            type: asset.type,
            name: asset.name,
          });
        } catch (error) {
          // console.error(`Event image ${i} upload error:`, error);
          // alert(`Failed to upload image ${i + 1}. Please try again.`);
          // throw error;
        }
      } else {
        // alert(`Image ${i + 1} has an invalid format. Please re-upload it.`);
        // throw new Error(`Invalid image format for image ${i + 1}`);
      }
    }

    updateCallback({ eventImages: updatedImages });
  };

  const handleUpdateEvent = async () => {
    try {
      const validation = validateEventData(eventData);
      setValidationErrors(validation.errors);

      if (!validation.isValid) {
        scrollToFirstError(validation.errors);
        return;
      }

      setIsSaving(true);
      let updatedEventData = { ...eventData };

      if (asoEbiData?.asoEbiImages?.length > 0 || eventData?.eventAttire) {
        updatedEventData.eventAttire = {
          asoEbiImages:
            asoEbiData?.asoEbiImages ||
            eventData?.eventAttire?.asoEbiImages ||
            [],
          refundDeadlineDate:
            asoEbiData?.refundDeadlineDate ||
            eventData?.eventAttire?.refundDeadlineDate ||
            null,
          isEventAttireCompulsory:
            asoEbiData?.isEventAttireCompulsory ??
            eventData?.eventAttire?.isEventAttireCompulsory ??
            false,
        };
      }

      try {
        await handleEventImageUpload(updatedEventData, (newData) => {
          updatedEventData = { ...updatedEventData, ...newData };
          setEventData(updatedEventData);
        });
      } catch (error) {
        // console.error("ERROR in handleEventImageUpload:", error);
        // alert("Failed to update event. Please try again.");
        setIsSaving(false);
        return;
      }

      if (updatedEventData.eventAttire?.asoEbiImages?.length > 0) {
        try {
          await handleEventAttireUpload(updatedEventData, (newData) => {
            updatedEventData = { ...updatedEventData, ...newData };
            setEventData(updatedEventData);
          });
        } catch (error) {
          // console.error("Event attire upload failed:", error);
          setIsSaving(false);
          return;
        }
      }

      let { startDate, endDate } = updatedEventData;
      if (startDate && endDate) {
        const start = new Date(startDate);
        const end = new Date(endDate);

        if (start > end) {
          startDate = end;
          endDate = start;
        }
      }

      const completeEventData = {
        ...updatedEventData,
        eventLandmark:
          updatedEventData.eventLandmark ||
          updatedEventData.landmark ||
          updatedEventData.customAddress,
        eventLocation:
          updatedEventData.eventLocation || updatedEventData.location,
        landmarkCoords: landmarkCoords || { latitude: 0, longitude: 0 },
        customAddress: customAddress || "",

        visibility: updatedEventData.visibility || "public",
        colorOfTheDay: updatedEventData.colorOfTheDay || "",

        eventAttire: updatedEventData.eventAttire
          ? {
              asoEbiImages: updatedEventData.eventAttire.asoEbiImages || [],
              refundDeadlineDate:
                formatDateForBackend(
                  updatedEventData.eventAttire.refundDeadlineDate,
                ) || null,
              isEventAttireCompulsory:
                updatedEventData.eventAttire.isEventAttireCompulsory || false,
            }
          : undefined,

        asoEbiData: undefined,

        cashGiftData: updatedEventData.cashGift
          ? updatedEventData.cashGiftData
          : undefined,
        entryFeeData: updatedEventData.entryFee
          ? {
              tickets: updatedEventData.entryFeeData?.tickets ?? [],
              isTicketMandatory:
                updatedEventData.entryFeeData?.isTicketMandatory ?? false,
              refundPolicy: updatedEventData.entryFeeData?.refundPolicy ?? "",
            }
          : undefined,

        ...(updatedEventData.dateOption === "multiple" && {
          eventDate: null,
          eventTime: null,
          startDate: null,
          startTime: null,
          endDate: null,
          endTime: null,
          multipleDates: updatedEventData.multipleDates?.map((dateEntry) => ({
            subTitle: dateEntry.subTitle,
            location: dateEntry.location,
            landmark: dateEntry.landmark,
            landmarkCoords: dateEntry.landmarkCoords,
            date: dateEntry.date ? formatDateForBackend(dateEntry.date) : null,
            time: dateEntry.time ? formatTimeForBackend(dateEntry.time) : null,
          })),
        }),

        ...(updatedEventData.dateOption === "startEnd" && {
          eventDate: null,
          eventTime: null,
          multipleDates: null,
          startDate: startDate ? formatDateForBackend(startDate) : null,
          startTime: updatedEventData.startTime
            ? formatTimeForBackend(updatedEventData.startTime)
            : null,
          endDate: endDate ? formatDateForBackend(endDate) : null,
          endTime: updatedEventData.endTime
            ? formatTimeForBackend(updatedEventData.endTime)
            : null,
        }),

        ...(updatedEventData.dateOption === "regular" && {
          startDate: null,
          startTime: null,
          endDate: null,
          endTime: null,
          multipleDates: null,
          eventDate: updatedEventData.eventDate
            ? formatDateForBackend(updatedEventData.eventDate)
            : null,
          eventTime: updatedEventData.eventTime
            ? formatTimeForBackend(updatedEventData.eventTime)
            : null,
        }),

        ...(!updatedEventData.dateOption && {
          startDate: null,
          startTime: null,
          endDate: null,
          endTime: null,
          multipleDates: null,
          eventDate: updatedEventData.eventDate
            ? formatDateForBackend(updatedEventData.eventDate)
            : null,
          eventTime: updatedEventData.eventTime
            ? formatTimeForBackend(updatedEventData.eventTime)
            : null,
        }),
      };

      await updateEventHandler(completeEventData);
    } catch (error) {
      // console.error("handleUpdateEvent error:", error);
      // alert("Failed to update event. Please try again.");
      setIsSaving(false);
    }
  };

  const updateEventHandler = async (completeEventData) => {
    try {
      const response = await axios.patch(
        `/event/${eventId}`,
        { completeEventData },
        { headers: { "Content-Type": "application/json" } },
      );
      setIsSaving(false);
      setSuccessModalVisible(true);
      setEventResponse({ ...response.data.data, status: "updated" });
      return response.data;
    } catch (error) {
      // console.error("updateEventHandler error:", error);
      setIsSaving(false);
      const message =
        error?.response?.data?.message || "Failed to update event";
      alert(`Error: ${message}`);
    }
  };

  const handleEventTypeSelect = (type) => {
    if (type === "Others") {
      setIsOtherEventType(true);
      setShowEventTypeDropdown(false);
    } else {
      setEventData((prev) => ({ ...prev, eventType: type }));
      setShowEventTypeDropdown(false);
      setIsOtherEventType(false);
      setCustomEventType("");
      if (validationErrors.eventType) {
        setValidationErrors((prev) => ({ ...prev, eventType: "" }));
      }
    }
  };

  const handleCustomEventTypeSubmit = () => {
    if (customEventType.trim()) {
      setEventData((prev) => ({ ...prev, eventType: customEventType.trim() }));
      setIsOtherEventType(false);
    }
  };

  const handleSelectDateOption = (optionId) => {
    setEventData((prev) => ({ ...prev, dateOption: optionId }));

    if (optionId === "multiple") {
      setShowDateTimeCustomizationModal(true);
      setIsAdditionalDatesChecked(true);
      setEventData((prev) => ({
        ...prev,
        dateOption: "multiple",
        eventDate: null,
        eventTime: null,
        startDate: "",
        startTime: "",
        endDate: "",
        endTime: "",
      }));
    } else if (optionId === "startEnd") {
      setShowDateTimeModal(true);
      setIsAdditionalDatesChecked(true);
      setEventData((prev) => ({
        ...prev,
        multipleDates: [
          {
            subTitle: "",
            date: null,
            time: null,
            location: "",
            landmark: "",
            landmarkCoords: undefined,
          },
        ],
        dateOption: "startEnd",
        eventDate: null,
        eventTime: null,
      }));
    } else if (optionId === "regular") {
      setIsSaveClicked(false);
      setIsAdditionalDatesChecked(false);
      setEventData((prev) => ({
        ...prev,
        multipleDates: [
          {
            subTitle: "",
            date: null,
            time: null,
            location: "",
            landmark: "",
            landmarkCoords: undefined,
          },
        ],
        dateOption: "regular",
        startDate: "",
        startTime: "",
        endDate: "",
        endTime: "",
      }));
    }

    setShowDateOptionsModal(false);
  };

  const toggleAdditionalDates = () => {
    if (!isAdditionalDatesChecked) {
      if (isSaveClicked) {
        if (eventData?.dateOption === "multiple") {
          setCurrentOptionSet(dateOptionsSet3);
        } else if (eventData?.dateOption === "startEnd") {
          setCurrentOptionSet(dateOptionsSet2);
        } else {
          setCurrentOptionSet(dateOptionsSet1);
        }
      } else {
        setCurrentOptionSet(dateOptionsSet1);
      }
      setShowDateOptionsModal(true);
      setIsAdditionalDatesChecked(true);
    } else {
      if (isSaveClicked) {
        if (eventData?.dateOption === "multiple") {
          setCurrentOptionSet(dateOptionsSet3);
        } else if (eventData?.dateOption === "startEnd") {
          setCurrentOptionSet(dateOptionsSet2);
        } else {
          setCurrentOptionSet(dateOptionsSet1);
        }
        setShowDateOptionsModal(true);
      } else {
        setIsAdditionalDatesChecked(false);
        setEventData((prev) => ({
          ...prev,
          multipleDates: [
            {
              subTitle: "",
              date: null,
              time: null,
              location: "",
              landmark: "",
              landmarkCoords: undefined,
            },
          ],
          dateOption: "",
          startDate: "",
          startTime: "",
          endDate: "",
          endTime: "",
        }));
        setIsSaveClicked(false);
      }
    }
  };

  const handleSaveDateTimeCustomization = (entries) => {
    const mergedEntries = entries.map((entry, index) => {
      const existingEntry = eventData?.multipleDates?.[index];

      return {
        ...entry,
        time: entry.time || existingEntry?.time || null,
        date: entry.date,
        landmark: entry.landmark,
        landmarkCoords: entry.landmarkCoords,
      };
    });

    setEventData((prev) => ({ ...prev, multipleDates: mergedEntries }));
    setShowDateTimeCustomizationModal(false);
    setIsSaveClicked(true);
  };

  const handleDateTimeSave = (dateTimeData) => {
    setEventData((prev) => ({
      ...prev,
      startDate: dateTimeData.startDate,
      endDate: dateTimeData.endDate,
      startTime: dateTimeData.startTime,
      location: prev.location || prev.eventLocation || "",
    }));
    setShowDateTimeModal(false);
    setIsSaveClicked(true);
  };

  const handleDefaultDateChange = (date) => {
    setEventData((prev) => ({ ...prev, eventDate: date }));
    if (validationErrors.eventDate) {
      setValidationErrors((prev) => ({ ...prev, eventDate: "" }));
    }
  };

  const handleDefaultTimeChange = (time) => {
    setEventData((prev) => ({ ...prev, eventTime: time }));
    if (validationErrors.eventTime) {
      setValidationErrors((prev) => ({ ...prev, eventTime: "" }));
    }
  };

  const handleStartDateChange = (date) => {
    if (!date || isNaN(date.getTime())) return;
    setEventData((prev) => ({ ...prev, startDate: date }));
    if (validationErrors.startDate) {
      setValidationErrors((prev) => ({ ...prev, startDate: "" }));
    }
  };

  const handleEndDateChange = (date) => {
    if (!date || isNaN(date.getTime())) return;
    setEventData((prev) => ({ ...prev, endDate: date }));
    if (validationErrors.endDate) {
      setValidationErrors((prev) => ({ ...prev, endDate: "" }));
    }
  };

  const handleStartTimeChange = (time) => {
    if (!time || isNaN(time.getTime())) return;
    setEventData((prev) => ({ ...prev, startTime: time }));
    if (validationErrors.startTime) {
      setValidationErrors((prev) => ({ ...prev, startTime: "" }));
    }
  };

  const toggleAsoEbi = () => {
    const newAsoEbiState = !eventData?.eventAttire;
    setEventData((prev) => ({
      ...prev,
      asoEbi: newAsoEbiState,
      eventAttire: newAsoEbiState,
    }));

    if (newAsoEbiState) {
      setShowAsoEbiModal(true);
    } else {
      setAsoEbiData({
        asoEbiImages: [],
        refundPolicy: "",
        refundDeadlineDate: null,
        isEventAttireCompulsory: false,
      });
    }
  };

  const handleAsoEbiSave = (data) => {
    setAsoEbiData(data);
    setEventData((prev) => ({
      ...prev,
      eventAttire: {
        asoEbiImages:
          data.asoEbiImages && data.asoEbiImages.length > 0
            ? data.asoEbiImages
            : prev.eventAttire?.asoEbiImages || [],
        refundDeadlineDate:
          data.refundDeadlineDate !== undefined
            ? data.refundDeadlineDate
            : null,
        isEventAttireCompulsory: data.isEventAttireCompulsory ?? false,
      },
      isEventAttireCompulsory: data.isEventAttireCompulsory ?? false,
    }));
    setShowAsoEbiModal(false);
  };

  const handleCashGiftSave = (data) => {
    setEventData((prev) => ({
      ...prev,
      cashGiftData: data,
      bankDetails: data.bankDetails,
      cashGift: true,
      isCashGiftAccepted: true,
    }));
    setShowCashGiftModal(false);
  };

  const handleEntryTicketSave = (tickets) => {
    setEventData((prev) => {
      const updated = {
        ...prev,
        entryFeeData: {
          tickets: tickets,
          isTicketMandatory: prev.entryFeeData?.isTicketMandatory ?? false,
          refundPolicy: prev.entryFeeData?.refundPolicy ?? "",
        },
        ticketFee: tickets,
      };
      return updated;
    });
    setShowEntryTicketModal(false);
  };

  const toggleCashGift = () => {
    const newCashGiftState = !eventData?.cashGift;
    setEventData((prev) => ({
      ...prev,
      cashGift: newCashGiftState,
      isCashGiftAccepted: newCashGiftState,
    }));
  };

  const toggleEntryFee = () => {
    const newEntryFeeState = !eventData?.entryFee;

    setEventData((prev) => {
      const updated = {
        ...prev,
        entryFee: newEntryFeeState,
        isEntryFeeApplicable: newEntryFeeState,
        entryFeeData: newEntryFeeState
          ? (prev.entryFeeData ?? {
              tickets: [],
              isTicketMandatory: false,
              refundPolicy: "",
            })
          : undefined,
      };
      return updated;
    });

    if (newEntryFeeState) {
      setShowEntryTicketModal(true);
    }
  };

  const handleImagesSubmit = (images) => {
    if (validationErrors.eventImages) {
      setValidationErrors((prev) => ({ ...prev, eventImages: "" }));
    }

    setSelectedImages(images);
    setEventData((prev) => ({
      ...prev,
      eventImages: images.map((image) => ({
        uri: image.uri,
        type: image.type,
        name: image.name,
        file: image.file,
      })),
    }));
  };

  const removeSelectedImage = (index) => {
    const newImages = [...selectedImages];
    newImages.splice(index, 1);
    setSelectedImages(newImages);
    setEventData((prev) => ({
      ...prev,
      eventImages: newImages.length > 0 ? newImages : [],
    }));

    if (newImages.length > 0 && validationErrors.eventImages) {
      setValidationErrors((prev) => ({ ...prev, eventImages: "" }));
    }
  };

  const updateDateTime = (index, field, value) => {
    const updatedDates = [...eventData.multipleDates];
    updatedDates[index] = { ...updatedDates[index], [field]: value };
    setEventData((prev) => ({ ...prev, multipleDates: updatedDates }));
  };

  const handleLandmarkChange = (text) => {
    setEventData((prev) => ({ ...prev, eventLandmark: text }));
    if (validationErrors.eventLandmark || validationErrors.location) {
      setValidationErrors((prev) => ({
        ...prev,
        eventLandmark: "",
        location: "",
      }));
    }
  };

  const handlePlaceSelected = (place) => {
    if (!place) {
      setEventData((prev) => ({ ...prev, eventLandmark: "" }));
      setLandmarkCoords(null);
      return;
    }
    setEventData((prev) => ({ ...prev, eventLandmark: place.address }));
    setLandmarkCoords(
      place.coords?.latitude != null && place.coords?.longitude != null
        ? { latitude: place.coords.latitude, longitude: place.coords.longitude }
        : null,
    );
  };

  const addNewMultipleDateEntry = () => {
    setEventData((prev) => ({
      ...prev,
      multipleDates: [
        ...prev.multipleDates,
        {
          subTitle: "",
          date: null,
          time: null,
          location: "",
          landmark: "",
          landmarkCoords: undefined,
        },
      ],
    }));
  };

  const handleProceed = () => {
    setSuccessModalVisible(false);
    navigate("/home/host");
  };

  const handleCloseSuccessModal = async () => {
    setSuccessModalVisible(false);
    navigate("/home/host");
  };

  const renderImagePreviews = () => {
    if (!eventData?.eventImages || eventData.eventImages.length === 0)
      return null;

    return (
      <div className="edit-event-image-previews-container">
        {eventData.eventImages.map((image, index) => (
          <div key={index} className="edit-event-image-preview-wrapper">
            <img
              src={image.uri}
              alt={`Preview ${index + 1}`}
              className="edit-event-image-preview"
            />
            <button
              className="edit-event-remove-preview-button"
              onClick={() => removeSelectedImage(index)}
            >
              ×
            </button>
          </div>
        ))}
      </div>
    );
  };

  const renderDateTimeSection = () => {
    if (eventData?.dateOption === "multiple") {
      return (
        <div className="edit-event-date-time-entry-container">
          {eventData.multipleDates.map((entry, index) => (
            <div key={index} className="edit-event-single-entry">
              <label className="edit-event-label">
                Sub Event Title {index > 0 && index + 1}
              </label>
              <input
                type="text"
                className={`edit-event-input ${
                  validationErrors[`dateTitle_${index}`]
                    ? "edit-event-input-error"
                    : ""
                }`}
                placeholder="Enter Sub Event Title"
                value={entry.subTitle}
                onChange={(e) => {
                  updateDateTime(index, "subTitle", e.target.value);
                  const key = `dateTitle_${index}`;
                  if (validationErrors[key]) {
                    setValidationErrors((prev) => ({ ...prev, [key]: "" }));
                  }
                }}
              />
              {validationErrors[`dateTitle_${index}`] && (
                <span className="edit-event-error-text">
                  {validationErrors[`dateTitle_${index}`]}
                </span>
              )}

              <label className="edit-event-label">Address</label>
              <LandmarkInput
                value={entry.landmark || ""}
                onChangeText={(text) => {
                  updateDateTime(index, "landmark", text);
                  const key = `dateLandmark_${index}`;
                  if (validationErrors[key]) {
                    setValidationErrors((prev) => ({ ...prev, [key]: "" }));
                  }
                }}
                onPlaceSelected={(place) => {
                  if (!place) {
                    updateDateTime(index, "landmark", "");
                    updateDateTime(index, "landmarkCoords", null);
                    return;
                  }
                  updateDateTime(index, "landmark", place.address);
                  updateDateTime(
                    index,
                    "landmarkCoords",
                    place.coords?.latitude != null &&
                      place.coords?.longitude != null
                      ? {
                          latitude: place.coords.latitude,
                          longitude: place.coords.longitude,
                        }
                      : null,
                  );
                }}
                placeholder="Type your address here..."
              />
              <ErrorText error={validationErrors[`dateLandmark_${index}`]} />

              <label className="edit-event-label">
                Full Address Description
              </label>
              <textarea
                className={`edit-event-textarea ${
                  validationErrors[`dateLocation_${index}`]
                    ? "edit-event-input-error"
                    : ""
                }`}
                placeholder="Describe the address in full..."
                value={entry.location}
                onChange={(e) => {
                  updateDateTime(index, "location", e.target.value);
                  const key = `dateLocation_${index}`;
                  if (validationErrors[key]) {
                    setValidationErrors((prev) => ({ ...prev, [key]: "" }));
                  }
                }}
                rows={3}
              />
              {validationErrors[`dateLocation_${index}`] && (
                <span className="edit-event-error-text">
                  {validationErrors[`dateLocation_${index}`]}
                </span>
              )}

              <div className="edit-event-date-time-container">
                <div className="edit-event-date-time-column">
                  <label className="edit-event-label">Date</label>
                  <input
                    type="date"
                    className={`edit-event-input ${
                      validationErrors[`dateDate_${index}`]
                        ? "edit-event-input-error"
                        : ""
                    }`}
                    value={formatDateForEditInput(entry.date)}
                    onChange={(e) => {
                      const newDate = createDateFromEditInput(e.target.value);
                      updateDateTime(index, "date", newDate);
                      const key = `dateDate_${index}`;
                      if (validationErrors[key]) {
                        setValidationErrors((prev) => ({ ...prev, [key]: "" }));
                      }
                    }}
                  />
                  {validationErrors[`dateDate_${index}`] && (
                    <span className="edit-event-error-text">
                      {validationErrors[`dateDate_${index}`]}
                    </span>
                  )}
                </div>

                <div className="edit-event-date-time-column">
                  <label className="edit-event-label">Time</label>
                  <input
                    type="time"
                    className={`edit-event-input ${
                      validationErrors[`dateTime_${index}`]
                        ? "edit-event-input-error"
                        : ""
                    }`}
                    value={formatTimeForEditInput(entry.time)}
                    onChange={(e) => {
                      const [hours, minutes] = e.target.value.split(":");
                      const date = new Date();
                      date.setHours(Number.parseInt(hours, 10));
                      date.setMinutes(Number.parseInt(minutes, 10));
                      updateDateTime(index, "time", date);
                      const key = `dateTime_${index}`;
                      if (validationErrors[key]) {
                        setValidationErrors((prev) => ({ ...prev, [key]: "" }));
                      }
                    }}
                  />
                  {validationErrors[`dateTime_${index}`] && (
                    <span className="edit-event-error-text">
                      {validationErrors[`dateTime_${index}`]}
                    </span>
                  )}
                </div>
              </div>

              {index > 0 && (
                <button
                  className="edit-event-remove-button"
                  onClick={() => {
                    const updatedDates = eventData.multipleDates.filter(
                      (_, i) => i !== index,
                    );
                    setEventData((prev) => ({
                      ...prev,
                      multipleDates: updatedDates,
                    }));
                  }}
                >
                  Remove
                </button>
              )}
            </div>
          ))}

          <button
            className="edit-event-add-button"
            onClick={addNewMultipleDateEntry}
          >
            Add Another Sub Event
          </button>
        </div>
      );
    }

    if (eventData?.dateOption === "startEnd") {
      return (
        <>
          <div className="edit-event-date-container">
            <div className="edit-event-date-section">
              <label className="edit-event-label">Start Date</label>
              <input
                type="date"
                className={`edit-event-input ${
                  validationErrors.startDate ? "edit-event-input-error" : ""
                }`}
                value={formatDateForEditInput(eventData.startDate)}
                onChange={(e) => {
                  const newDate = createDateFromEditInput(e.target.value);
                  handleStartDateChange(newDate);
                }}
              />
              {validationErrors.startDate && (
                <span className="edit-event-error-text">
                  {validationErrors.startDate}
                </span>
              )}
            </div>

            <div className="edit-event-date-section">
              <label className="edit-event-label">End Date</label>
              <input
                type="date"
                className={`edit-event-input ${
                  validationErrors.endDate ? "edit-event-input-error" : ""
                }`}
                value={formatDateForEditInput(eventData.endDate)}
                onChange={(e) => {
                  const newDate = createDateFromEditInput(e.target.value);
                  handleEndDateChange(newDate);
                }}
                min={formatDateForEditInput(eventData.startDate)}
              />
              {validationErrors.endDate && (
                <span className="edit-event-error-text">
                  {validationErrors.endDate}
                </span>
              )}
            </div>
          </div>

          <div className="edit-event-time-section">
            <label className="edit-event-label">Time</label>
            <input
              type="time"
              className={`edit-event-input ${
                validationErrors.startTime ? "edit-event-input-error" : ""
              }`}
              value={formatTimeForEditInput(eventData.startTime)}
              onChange={(e) => {
                const [hours, minutes] = e.target.value.split(":");
                const date = new Date();
                date.setHours(Number.parseInt(hours, 10));
                date.setMinutes(Number.parseInt(minutes, 10));
                handleStartTimeChange(date);
              }}
            />
            {validationErrors.startTime && (
              <span className="edit-event-error-text">
                {validationErrors.startTime}
              </span>
            )}
          </div>

          <label className="edit-event-label">Address</label>

          <LandmarkInput
            value={eventData.eventLandmark || eventData.landmark || ""}
            onChangeText={handleLandmarkChange}
            onPlaceSelected={handlePlaceSelected}
            placeholder="Type your address here..."
          />

          <label className="edit-event-label">Full Address Description</label>
          <div className="edit-event-location-input">
            <input
              className="edit-event-location-input-text"
              placeholder="Enter Event Location Venue"
              value={eventData.location || eventData.eventLocation || ""}
              onChange={(e) => {
                setEventData((prev) => ({
                  ...prev,
                  eventLocation: e.target.value,
                  location: e.target.value,
                }));
                if (validationErrors.location) {
                  setValidationErrors((prev) => ({ ...prev, location: "" }));
                }
              }}
            />
            <i className="fas fa-location-arrow"></i>
          </div>
          <ErrorText error={validationErrors.location} />
        </>
      );
    }

    return null;
  };

  const shouldShowDefaultFields =
    !isSaveClicked ||
    (eventData?.dateOption !== "multiple" &&
      eventData?.dateOption !== "startEnd");

  const shouldShowDefaultLocation = shouldShowDefaultFields;

  if (isLoading) {
    return (
      <div className="edit-event-loading">
        <div className="edit-event-spinner"></div>
        <p>Loading event data...</p>
      </div>
    );
  }

  if (!eventData) {
    return (
      <div className="edit-event-error">
        <p>Failed to load event data</p>
        <button onClick={() => navigate(-1)}>Go Back</button>
      </div>
    );
  }

  return (
    <div className="edit-event-container">
      <Header />

      <div className="edit-event-header">
        <EventHeader
          title="Update Event"
          showBackButton={true}
          showStatus={false}
          showDate={false}
        />
      </div>

      <div className="edit-event-content">
        <div className="edit-event-section">
          <label className="edit-event-label">Event Type</label>
          {isOtherEventType ? (
            <div className="edit-event-custom-type-container">
              <input
                type="text"
                className={`edit-event-input ${
                  validationErrors.eventType ? "edit-event-input-error" : ""
                }`}
                placeholder="Enter your event type"
                value={customEventType}
                onChange={(e) => {
                  setCustomEventType(e.target.value);
                  if (validationErrors.eventType) {
                    setValidationErrors((prev) => ({ ...prev, eventType: "" }));
                  }
                }}
                onKeyPress={(e) => {
                  if (e.key === "Enter") handleCustomEventTypeSubmit();
                }}
              />
              <button
                className="edit-event-submit-button"
                onClick={handleCustomEventTypeSubmit}
              >
                Submit
              </button>
            </div>
          ) : (
            <div
              className={`edit-event-dropdown-button ${
                validationErrors.eventType ? "edit-event-input-error" : ""
              }`}
              onClick={() => setShowEventTypeDropdown(!showEventTypeDropdown)}
            >
              <span>{eventData?.eventType || "Select Event Type"}</span>
              <DownArrowIcon />
            </div>
          )}
          {validationErrors.eventType && (
            <span className="edit-event-error-text">
              {validationErrors.eventType}
            </span>
          )}

          {showEventTypeDropdown && (
            <div className="edit-event-dropdown">
              {eventTypes.map((type) => (
                <div
                  key={type}
                  className="edit-event-dropdown-item"
                  onClick={() => handleEventTypeSelect(type)}
                >
                  {type}
                </div>
              ))}
            </div>
          )}
        </div>

        <div className="edit-event-section">
          <label className="edit-event-label">
            {eventData?.dateOption === "multiple"
              ? "Event Main Title"
              : "Event Title"}
          </label>
          <input
            type="text"
            data-error="eventTitle"
            className={`edit-event-input ${
              validationErrors.eventTitle ? "edit-event-input-error" : ""
            }`}
            placeholder="Enter Event Title"
            value={eventData?.eventTitle || ""}
            onChange={(e) => {
              setEventData((prev) => ({ ...prev, eventTitle: e.target.value }));
              if (validationErrors.eventTitle) {
                setValidationErrors((prev) => ({ ...prev, eventTitle: "" }));
              }
            }}
          />
          {validationErrors.eventTitle && (
            <span className="edit-event-error-text">
              {validationErrors.eventTitle}
            </span>
          )}
          <p className="edit-event-helper-text">
            Event title could be the event hashtag and event name such as
            wedding, Naming ceremony etc
          </p>
        </div>

        {renderDateTimeSection()}

        {shouldShowDefaultFields && (
          <div className="edit-event-default-date-time-container">
            <div className="edit-event-date-time-container">
              <div className="edit-event-date-time-column">
                <label className="edit-event-label">Date</label>
                <input
                  type="date"
                  data-error="date"
                  className={`edit-event-input ${
                    validationErrors.eventDate ? "edit-event-input-error" : ""
                  }`}
                  value={formatDateForEditInput(eventData.eventDate)}
                  onChange={(e) => {
                    const newDate = createDateFromEditInput(e.target.value);
                    handleDefaultDateChange(newDate);
                  }}
                />
                {validationErrors.eventDate && (
                  <span className="edit-event-error-text">
                    {validationErrors.eventDate}
                  </span>
                )}
              </div>

              <div className="edit-event-date-time-column">
                <label className="edit-event-label">Time</label>
                <input
                  type="time"
                  data-error="time"
                  className={`edit-event-input ${
                    validationErrors.eventTime ? "edit-event-input-error" : ""
                  }`}
                  value={formatTimeForEditInput(eventData.eventTime)}
                  onChange={(e) => {
                    const [hours, minutes] = e.target.value.split(":");
                    const date = new Date();
                    date.setHours(Number.parseInt(hours, 10));
                    date.setMinutes(Number.parseInt(minutes, 10));
                    handleDefaultTimeChange(date);
                  }}
                />
                {validationErrors.eventTime && (
                  <span className="edit-event-error-text">
                    {validationErrors.eventTime}
                  </span>
                )}
              </div>
            </div>
          </div>
        )}

        <div
          className="edit-event-checkbox-row"
          onClick={toggleAdditionalDates}
        >
          <div
            className={`edit-event-checkbox ${
              isAdditionalDatesChecked ? "checked" : ""
            }`}
          >
            {isAdditionalDatesChecked && <CheckIcon />}
          </div>
          <label className="edit-event-checkbox-label">
            Update Date & Time
          </label>
        </div>

        {shouldShowDefaultLocation && (
          <>
            <label className="edit-event-label">Address</label>

            {!showCustomAddressField && (
              <LandmarkInput
                data-error="address"
                value={eventData.eventLandmark || eventData.landmark || ""}
                onChangeText={handleLandmarkChange}
                onPlaceSelected={handlePlaceSelected}
                placeholder="Type your address here..."
              />
            )}

            {showCustomAddressField && (
              <input
                type="text"
                data-error="customAddress"
                className="edit-event-input"
                value={eventData.customAddress || ""}
                onChange={(e) => {
                  setEventData((prev) => ({
                    ...prev,
                    customAddress: e.target.value,
                  }));
                }}
                placeholder="Enter custom address"
              />
            )}

            <button
              className="edit-event-custom-address-button"
              onClick={() => {
                setShowCustomAddressField(!showCustomAddressField);
                if (showCustomAddressField) {
                  setLandmark(landmark);
                  setLandmarkCoords(landmarkCoords);
                  setEventData((prev) => ({
                    ...prev,
                    landmark: landmark,
                    landmarkCoords: landmarkCoords,
                  }));
                } else {
                  setLandmark(customAddress);
                  setLandmarkCoords(null);
                  setEventData((prev) => ({
                    ...prev,
                    landmark: customAddress,
                    landmarkCoords: null,
                  }));
                }
              }}
            >
              {showCustomAddressField
                ? "Use Google Maps"
                : "Use Custom Address"}
            </button>

            <p className="edit-event-helper-text">
              Please enter a full and complete address, including all necessary
              details, like the street name, city, state, and ZIP code
            </p>

            <label className="edit-event-label">Full Address Description</label>
            <textarea
              data-error="fullAddressDescription"
              className={`edit-event-textarea ${
                validationErrors.location ? "edit-event-input-error" : ""
              }`}
              placeholder="Describe the address in full..."
              value={eventData.location || eventData.eventLocation || ""}
              onChange={(e) => {
                setEventData((prev) => ({
                  ...prev,
                  eventLocation: e.target.value,
                  location: e.target.value,
                }));
                if (validationErrors.location) {
                  setValidationErrors((prev) => ({ ...prev, location: "" }));
                }
              }}
              rows={3}
            />
            {validationErrors.location && (
              <span className="edit-event-error-text">
                {validationErrors.location}
              </span>
            )}
          </>
        )}

        <div className="edit-event-section">
          <label className="edit-event-label">Description</label>
          <textarea
            data-error="additionalDetails"
            className="edit-event-textarea"
            placeholder="Enter a description..."
            value={eventData?.eventDescription || ""}
            onChange={(e) =>
              setEventData((prev) => ({
                ...prev,
                eventDescription: e.target.value,
              }))
            }
            rows={5}
          />
        </div>

        <div className="edit-event-section">
          <label className="edit-event-label">Upload Image attachment</label>
          <p className="edit-event-image-helper-text">
            Select and upload an image or a banner for the event, max image size
            should be 2mb
          </p>
          {validationErrors.eventImages && (
            <span className="edit-event-error-text">
              {validationErrors.eventImages}
            </span>
          )}

          {renderImagePreviews()}

          <button
            className="edit-event-select-file-button"
            onClick={() => setShowUploadEventImageModal(true)}
          >
            <ImagePlaceholder />
            <span>
              {eventData?.eventImages && eventData.eventImages.length > 0
                ? "Update Images"
                : "Select Images"}
            </span>
          </button>
        </div>

        <div className="edit-event-section">
          <label className="edit-event-label">Preferred Currency</label>
          <div
            className={`edit-event-dropdown-button edit-event-currency-disabled ${
              validationErrors.preferredCurrency ? "edit-event-input-error" : ""
            }`}
            title="Currency cannot be changed after event creation"
          >
            <span>
              {eventData?.preferredCurrency === "USD"
                ? "USD ($) - United States Dollar"
                : eventData?.preferredCurrency === "NGN"
                  ? "NGN (₦) - Nigerian Naira"
                  : "Select Currency"}
            </span>
            <DownArrowIcon />
          </div>
          <p className="edit-event-helper-text">
            Currency cannot be changed after event creation. This is used for
            tickets, attire, and cash gifts.
          </p>
        </div>

        <div
          className="edit-event-visibility-container"
          ref={visibilityRef}
          collapsable={false}
        >
          <label className="edit-event-label">
            Event Visibility <span className="edit-event-required">*</span>
          </label>
          <div className="edit-event-helper-text">
            Choose whether this event should be publicly visible or private.
            Public events can be discovered by anyone, while private events
            require an invite code to access.
          </div>

          <div
            className={`edit-event-dropdown-button ${
              validationErrors.visibility ? "edit-event-input-error" : ""
            }`}
            onClick={() => setShowVisibilityDropdown(!showVisibilityDropdown)}
          >
            <div className="edit-event-visibility-button-content">
              <span className="edit-event-visibility-icon">
                {eventData?.visibility === "public"
                  ? "🌐"
                  : eventData?.visibility === "private"
                    ? "🔒"
                    : ""}
              </span>
              <div className="edit-event-visibility-text-container">
                <span
                  className={
                    eventData?.visibility
                      ? "edit-event-visibility-selected-text"
                      : "edit-event-visibility-placeholder-text"
                  }
                >
                  {eventData?.visibility === "public"
                    ? "Public Event"
                    : eventData?.visibility === "private"
                      ? "Private Event"
                      : "Select Event Visibility"}
                </span>
                {eventData?.visibility && (
                  <span className="edit-event-visibility-description">
                    {eventData?.visibility === "public"
                      ? "Anyone can view and access this event"
                      : "Only accessible with an invite code"}
                  </span>
                )}
              </div>
            </div>
            <DownArrowIcon />
          </div>

          {showVisibilityDropdown && (
            <div className="edit-event-visibility-dropdown">
              <div
                className={`edit-event-visibility-dropdown-item ${
                  eventData?.visibility === "public"
                    ? "edit-event-visibility-selected"
                    : ""
                }`}
                onClick={() => handleVisibilitySelect("public")}
              >
                <span className="edit-event-visibility-dropdown-icon">🌐</span>
                <div className="edit-event-visibility-dropdown-text">
                  <span className="edit-event-visibility-dropdown-label">
                    Public Event
                  </span>
                  <span className="edit-event-visibility-dropdown-description">
                    Anyone can view and access this event
                  </span>
                </div>
                {eventData?.visibility === "public" && (
                  <svg width="20" height="20" viewBox="0 0 20 20" fill="none">
                    <path
                      d="M10 0C4.48 0 0 4.48 0 10C0 15.52 4.48 20 10 20C15.52 20 20 15.52 20 10C20 4.48 15.52 0 10 0ZM8 15L3 10L4.41 8.59L8 12.17L15.59 4.58L17 6L8 15Z"
                      fill="#0e6a36"
                    />
                  </svg>
                )}
              </div>

              <div
                className={`edit-event-visibility-dropdown-item ${
                  eventData?.visibility === "private"
                    ? "edit-event-visibility-selected"
                    : ""
                }`}
                onClick={() => handleVisibilitySelect("private")}
              >
                <span className="edit-event-visibility-dropdown-icon">🔒</span>
                <div className="edit-event-visibility-dropdown-text">
                  <span className="edit-event-visibility-dropdown-label">
                    Private Event
                  </span>
                  <span className="edit-event-visibility-dropdown-description">
                    Only accessible with an invite code
                  </span>
                </div>
                {eventData?.visibility === "private" && (
                  <svg width="20" height="20" viewBox="0 0 20 20" fill="none">
                    <path
                      d="M10 0C4.48 0 0 4.48 0 10C0 15.52 4.48 20 10 20C15.52 20 20 15.52 20 10C20 4.48 15.52 0 10 0ZM8 15L3 10L4.41 8.59L8 12.17L15.59 4.58L17 6L8 15Z"
                      fill="#0e6a36"
                    />
                  </svg>
                )}
              </div>
            </div>
          )}

          <ErrorText error={validationErrors.visibility} />
        </div>

        <div className="edit-event-section">
          <label className="edit-event-label">
            Additional Information's{" "}
            <span className="edit-event-optional-text">(Optional)</span>
          </label>

          <label className="edit-event-label">Color(s) of the Day</label>
          <input
            type="text"
            data-error="colorOfTheDay"
            className="edit-event-input"
            placeholder="e.g. Gold and White"
            value={eventData?.colorOfTheDay || ""}
            onChange={(e) =>
              setEventData((prev) => ({
                ...prev,
                colorOfTheDay: e.target.value,
              }))
            }
          />
        </div>

        <div className="edit-event-checkbox-row" onClick={toggleAsoEbi}>
          <div
            className={`edit-event-checkbox ${
              eventData?.eventAttire ? "checked" : ""
            }`}
          >
            {eventData?.eventAttire && <CheckIcon />}
          </div>
          <label className="edit-event-checkbox-label">Event Attire</label>
        </div>

        <p className="edit-event-feature-description">
          Activate event attire to allow invited guests to pay for aso ebi,
          fila, gele, customised cloths & cap directly through the app. You set
          the terms for collection and refunds.
        </p>

        {eventData?.eventAttire && (
          <button
            className="edit-event-edit-button"
            onClick={() => setShowAsoEbiModal(true)}
          >
            {asoEbiData?.asoEbiImages?.length > 0
              ? "Update Aso Ebi Details"
              : "Add Aso Ebi Details"}
          </button>
        )}

        <div className="edit-event-checkbox-row" onClick={toggleCashGift}>
          <div
            className={`edit-event-checkbox ${
              eventData?.cashGift || eventData?.isCashGiftAccepted
                ? "checked"
                : ""
            }`}
          >
            {(eventData?.cashGift || eventData?.isCashGiftAccepted) && (
              <CheckIcon />
            )}
          </div>
          <label className="edit-event-checkbox-label">Cash Gift</label>
        </div>

        <p className="edit-event-feature-description">
          Activate Cash Gift and let guests show their support for your event
          with a monetary contribution, easily made through the app. You set the
          rules for collection and refunds.
        </p>

        {/* {(eventData?.cashGift || eventData?.isCashGiftAccepted) && (
          <button
            className="edit-event-edit-button"
            onClick={() => setShowCashGiftModal(true)}
          >
            {eventData?.bankDetails?.accountNumber
              ? "Update Cash Gift Details"
              : "Add Cash Gift Details"}
          </button>
        )} */}

        <div className="edit-event-checkbox-row" onClick={toggleEntryFee}>
          <div
            className={`edit-event-checkbox ${
              eventData?.isEntryFeeApplicable ? "checked" : ""
            }`}
          >
            {eventData?.isEntryFeeApplicable && <CheckIcon />}
          </div>
          <label className="edit-event-checkbox-label">
            Ticket (Entry Fee)
          </label>
        </div>

        <p className="edit-event-feature-description">
          Activate Gate Fee and let guests pay an entry fee to attend your
          event. You set the rules for collection and refunds.
        </p>

        {eventData?.isEntryFeeApplicable && (
          <button
            className="edit-event-edit-button"
            onClick={() => setShowEntryTicketModal(true)}
          >
            {eventData?.entryFeeData?.tickets?.length > 0
              ? "Update Entry Ticket Details"
              : "Add Entry Ticket Details"}
          </button>
        )}

        <CustomButton
          text={isSaving ? "Updating..." : "Update Event"}
          onClick={handleUpdateEvent}
          backgroundColor="#006400"
          fontSize={16}
          className="edit-event-update-button"
          disabled={isSaving}
        />
      </div>

      <DateOptionsModal
        visible={showDateOptionsModal}
        onClose={() => {
          setShowDateOptionsModal(false);
          if (!isSaveClicked && !eventData?.dateOption) {
            setIsAdditionalDatesChecked(false);
          }
        }}
        onSelectOption={handleSelectDateOption}
        options={currentOptionSet}
        title="Additional Date & Time"
        subtitle="Select the best option that fits your event type"
      />

      <DateTimeCustomizationModal
        visible={showDateTimeCustomizationModal}
        onClose={() => setShowDateTimeCustomizationModal(false)}
        onSave={handleSaveDateTimeCustomization}
        initialEntries={eventData?.multipleDates}
      />

      <DateTimeModal
        visible={showDateTimeModal}
        onClose={() => setShowDateTimeModal(false)}
        onSave={handleDateTimeSave}
        initialValues={{
          startDate: eventData?.startDate
            ? new Date(eventData.startDate)
            : undefined,
          endDate: eventData?.endDate ? new Date(eventData.endDate) : undefined,
          startTime: eventData?.startTime
            ? new Date(eventData.startTime)
            : undefined,
        }}
        errors={{
          startDate: validationErrors.startDate,
          endDate: validationErrors.endDate,
          startTime: validationErrors.startTime,
        }}
      />

      <UploadEventImageModal
        visible={showUploadEventImageModal}
        onClose={() => setShowUploadEventImageModal(false)}
        onSubmit={handleImagesSubmit}
        maxImages={4}
        title="Upload Event Image Attachment"
        subtitle="Upload a clear image of the event card, invite card or banner"
        defaultImages={eventData?.eventImages}
      />

      <AsoEbiModal
        visible={showAsoEbiModal}
        onClose={() => setShowAsoEbiModal(false)}
        onSave={handleAsoEbiSave}
        onImageUpload={(images) => {
          setAsoEbiData((prev) => ({ ...prev, asoEbiImages: images }));
        }}
        initialImages={asoEbiData?.asoEbiImages}
        initialRefundPolicy={asoEbiData?.refundDeadlineDate}
        isEventAttireCompulsory={asoEbiData?.isEventAttireCompulsory}
        preferredCurrency={eventData?.preferredCurrency}
      />

      <CashGiftModal
        visible={showCashGiftModal}
        onClose={() => setShowCashGiftModal(false)}
        onSubmit={handleCashGiftSave}
        initialBankDetails={eventData?.bankDetails ?? null}
      />

      <EntryTicketModal
        visible={showEntryTicketModal}
        onClose={() => setShowEntryTicketModal(false)}
        onSubmit={(tickets) => handleEntryTicketSave(tickets)}
        initialTickets={
          eventData?.entryFeeData?.tickets ?? eventData?.ticketFee ?? []
        }
        preferredCurrency={eventData?.preferredCurrency}
      />

      <EditEventSuccessmodal
        visible={successModalVisible}
        onClose={handleCloseSuccessModal}
        onProceed={handleProceed}
        title="Event Updated"
        description="Your Event has been updated successfully! The changes are now live."
        imagePath="/images/successModal.png"
      />
    </div>
  );
};

export default EditEvent;
